import { spaceEndpoints } from '@/api/apiEndpoint'
import { apiService } from './apiService'
import { DefaultResponse } from '@/common/types/common'



export const spaceService = {
  applySpace: async (
    companyId: number,
    serviceType: string
  ) => {
    const response = await apiService.post<DefaultResponse>(
      spaceEndpoints.applySpace(),
      {
        companyId,
        serviceType
      }
    )
    return response
  },
}
